{
  "error": {
    "server_connection_failed": "伺服器連線失敗。"
  },
  "term": {
    "actuator_endpoint": "Actuator 端點",
    "affects_all_instances": "影響全部 {count} 個執行個體",
    "affects_this_instance_only": "僅影響此執行個體",
    "all": "全部",
    "application": "應用程式",
    "applications_tc": "{n} 個應用程式 | {n} 個應用程式",
    "attributes": "屬性",
    "bytes": "位元組",
    "ok": "確定",
    "cancel": "取消",
    "clear": "清除",
    "cleared": "已清除",
    "close": "關閉",
    "confirm": "確認",
    "context_refresh": "重新整理內容",
    "context_refresh_failed": "失敗",
    "context_refreshed": "內容已重新整理",
    "delete": "刪除",
    "deleted": "已刪除",
    "duration": "持續時間",
    "epoch_time": "Epoch 時間",
    "percent": "百分之",
    "event": "事件",
    "ever": "任何時候",
    "execute": "執行",
    "executing": "執行中...",
    "execution_failed": "執行失敗。",
    "execution_successful": "執行成功。",
    "failed": "失敗",
    "fetching_data": "正在取得資料...",
    "fetch_failed": "取得資料失敗。",
    "float": "浮點數",
    "homepage": "首頁",
    "filter": "篩選",
    "filter_action": {
      "reset": "重設篩選條件"
    },
    "hours": "{count} 小時 | {count} 小時",
    "instance": "執行個體",
    "instances": "執行個體",
    "instances_tc": "{count} 個執行個體 | {count} 個執行個體",
    "integer": "整數",
    "keyword_search": "關鍵字搜尋",
    "menu": {
      "open": "開啟選單"
    },
    "milliseconds": "毫秒",
    "minutes": "{count} 分鐘 | {count} 分鐘",
    "name": "名稱",
    "operations": "作業",
    "save": "儲存",
    "stacktrace": "堆疊追蹤",
    "suppress": "隱藏通知",
    "time": "時間",
    "today": "今天",
    "unsuppress": "取消隱藏",
    "no_group": "無群組",
    "username": "使用者名稱",
    "go_to_previous_page": "前往上一頁",
    "go_to_page_n": "前往第 {page} 頁",
    "current_page": "第 {page} 頁，目前頁面",
    "go_to_next_page": "前往下一頁",
    "no_results_for_term": "找不到「{term}」的結果。"
  },
  "health": {
    "label": "健康狀態",
    "status": {
      "DOWN": "停止",
      "UP": "正常",
      "RESTRICTED": "受限",
      "UNKNOWN": "未知",
      "OUT_OF_SERVICE": "停止服務",
      "OFFLINE": "離線"
    }
  },
  "time_short": {
    "unknown": "未知",
    "milliseconds": "{count} 毫秒",
    "seconds": "{count} 秒",
    "minutes": "{count} 分",
    "hours": "{count} 小時",
    "days": "{count} 天",
    "weeks": "{count} 週",
    "months": "{count} 個月",
    "years": "{count} 年"
  }
}
